import { render, staticRenderFns } from "./RdxArrow.vue?vue&type=template&id=b969b28c&scoped=true&"
import script from "./RdxArrow.vue?vue&type=script&lang=ts&"
export * from "./RdxArrow.vue?vue&type=script&lang=ts&"
import style0 from "./RdxArrow.vue?vue&type=style&index=0&id=b969b28c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b969b28c",
  null
  
)

export default component.exports